import React, { useState } from 'react';
import loadable from '@loadable/component';
const ReactPlayer = loadable(() => import('react-player'));
import { graphql } from 'gatsby';
import Modal from 'react-modal';
import ArrowLgButton from './../Global/ArrowLgButton';
import AudioIcon from '../Global/AudioIcon';
import CtaLink from '../Global/CtaLink';
import RichText from '../Global/RichText';
//@ts-ignore
import * as styles from './promoted-content-styleB.module.css';
import { getColor, getMediaData, getMultiChoice } from '../Global/DataUtils';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import {
    KontentStringValue,
    CTAConfiguration,
    GeneralImages,
    KontentRadioMultiChoice,
    BrandColor,
    KontentMedia,
} from '../../../types/KontentProps';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import PlayArrow from '../Global/PlayArrow';
import AnchorLink from '../Global/AnchorLink';
import {
    optimizeKontentImageUrl,
    buildKontentSrcSet,
} from '../Global/DataUtils';

type itemsAlignmentType =
    | 'center_float'
    | 'top_float'
    | 'bottom_float'
    | undefined;

interface videoOrAudiomedia {
    value: {
        url: string;
    }[];
}
interface videoOrAudioFileLocationmedia {
    value: {
        codename: string;
    }[];
}

interface Props extends CTAConfiguration, GeneralImages {
    attribution_certification?: KontentStringValue;
    attribution_name?: KontentStringValue;
    content_panel__content_panel_color?: BrandColor;
    content_panel__content_panel_font_color?: BrandColor;
    cta_type?: videoOrAudioFileLocationmedia;
    headline: KontentStringValue;
    paragraph: KontentStringValue;
    primary_image_alignment?: KontentRadioMultiChoice<itemsAlignmentType>;
    video_or_audio_file_location?: videoOrAudioFileLocationmedia;
    video_or_audio_file?: videoOrAudiomedia;
    video_or_audio_file_link?: KontentStringValue;
    icon_for_cta_button?: KontentMedia;
    primary_image?: KontentMedia;
    kontentItemId?: string;
}

const PromotedContentStyleB: React.FC<Props> = ({
    attribution_certification,
    attribution_name,
    content_panel__content_panel_color,
    content_panel__content_panel_font_color,
    cta_type,
    headline,
    paragraph,
    primary_image,
    primary_image_alignment,
    video_or_audio_file_location,
    video_or_audio_file,
    video_or_audio_file_link,
    cta_configuration__cta_label,
    cta_configuration__cta_location,
    cta_configuration__cta_window_action,
    cta_configuration__cta_location_anchor_point,
    icon_for_cta_button,
    kontentItemId,
}) => {
    const [showControl, setShowControl] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);

    const videoOrAudioLink = video_or_audio_file_link?.value;
    const buttonType = cta_type?.value[0]?.codename;
    const imageAlignmentSelected = getMultiChoice(primary_image_alignment);
    const imageAlignmentClass = setImageAlignmentClass(imageAlignmentSelected);

    const primaryImage = primary_image && getImageData(primary_image);
    const ctaIcon = getMediaData(icon_for_cta_button);
    const backgroundColor = getColor(content_panel__content_panel_color);
    const textColor = getColor(content_panel__content_panel_font_color);

    const videoOrAudioFileUrl =
        video_or_audio_file?.value.length !== 0
            ? video_or_audio_file?.value[0]?.url
            : '';

    const audioOrVideoUrl =
        video_or_audio_file_location?.value[0]?.codename === 'link'
            ? video_or_audio_file_link?.value
            : videoOrAudioFileUrl;
    const handleClick = () => {
        video_or_audio_file_location?.value[0]?.codename === 'attached'
            ? setIsOpen(true)
            : window.open(videoOrAudioLink, '_blank');
    };

    const updatedBackgroundColor = backgroundColor ? backgroundColor : '';
    const updatedTextColor = textColor ? textColor : '';

    return (
        <div className={styles.wrapper} data-kontent-item-id={kontentItemId}>
            <div
                className={styles.container + ' ' + imageAlignmentClass}
                style={{ backgroundColor: updatedBackgroundColor }}
            >
                <div className={styles.innerContent}>
                    <div className={styles.videoWrapper}>
                        <div className={styles.modal}>
                            {primaryImage?.image && (
                                <div data-kontent-element-codename="primary_image">
                                    <img
                                        src={
                                            primaryImage.image
                                                ? optimizeKontentImageUrl(
                                                      (primaryImage.image
                                                          ?.url ||
                                                          primaryImage.image) as string,
                                                      {
                                                          w: 800,
                                                          fit: 'crop',
                                                          q: 80,
                                                          auto: 'format',
                                                      }
                                                  )
                                                : ''
                                        }
                                        srcSet={
                                            primaryImage.image
                                                ? buildKontentSrcSet(
                                                      (primaryImage.image
                                                          ?.url ||
                                                          primaryImage.image) as string,
                                                      800,
                                                      {
                                                          fit: 'crop',
                                                          q: 80,
                                                          auto: 'format',
                                                      }
                                                  )
                                                : ''
                                        }
                                        sizes="(max-width: 800px) 100vw, 800px"
                                        alt={primaryImage.alt}
                                        width={800}
                                        height={undefined}
                                        loading="lazy"
                                        className={styles.primaryimage}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                            )}
                            {buttonType === 'video_play' && (
                                <div
                                    className={styles.playArrow}
                                    onClick={handleClick}
                                >
                                    <PlayArrow
                                        heightWidth="4rem"
                                        strokeColor="#ffffff"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div
                        className={styles.contentBox}
                        style={{
                            backgroundColor: updatedBackgroundColor,
                            color: updatedTextColor,
                        }}
                    >
                        {headline?.value && (
                            <div className={styles.headline}>
                                <h3 data-kontent-element-codename="headline">
                                    {' '}
                                    {headline?.value}
                                </h3>
                            </div>
                        )}
                        {paragraph.value !== '<p><br></p>' && (
                            <div className={styles.paragraph}>
                                {RichText(
                                    paragraph,
                                    false,
                                    undefined,
                                    undefined,
                                    'paragraph'
                                )}
                            </div>
                        )}
                        {buttonType === 'standard_button' && (
                            <div className={styles.ctaContainer}>
                                {!cta_configuration__cta_location?.value
                                    ?.length &&
                                cta_configuration__cta_location_anchor_point ? (
                                    <AnchorLink
                                        targetId={
                                            cta_configuration__cta_location_anchor_point?.value
                                        }
                                        color={updatedTextColor}
                                    >
                                        {cta_configuration__cta_label?.value ||
                                            ''}
                                    </AnchorLink>
                                ) : cta_configuration__cta_label?.value ? (
                                    <CtaLink
                                        href={BuildLinkHref(
                                            cta_configuration__cta_location,
                                            cta_configuration__cta_location_anchor_point
                                        )}
                                        target={
                                            getMultiChoice(
                                                cta_configuration__cta_window_action
                                            ) === 'new_window'
                                                ? '_blank'
                                                : undefined
                                        }
                                        visualStyle="outlineLight"
                                        color={updatedTextColor}
                                    >
                                        {cta_configuration__cta_label?.value ||
                                            ''}
                                    </CtaLink>
                                ) : null}
                            </div>
                        )}
                        {buttonType === 'audio_file' && (
                            <div
                                className={styles.ctaContainer}
                                onClick={() => {
                                    setShowControl(true);
                                }}
                            >
                                <CtaLink
                                    target={
                                        getMultiChoice(
                                            cta_configuration__cta_window_action
                                        ) === 'new_window'
                                            ? '_blank'
                                            : undefined
                                    }
                                    visualStyle={'outlineLight'}
                                    color={updatedTextColor}
                                >
                                    {showControl ? (
                                        <div>
                                            <audio
                                                controls
                                                autoPlay
                                                className={styles.audioPlayer}
                                            >
                                                <source
                                                    src={audioOrVideoUrl}
                                                    type="audio/mpeg"
                                                ></source>
                                            </audio>
                                        </div>
                                    ) : (
                                        <div className={styles.audioLabel}>
                                            <div>
                                                {
                                                    cta_configuration__cta_label?.value
                                                }
                                            </div>

                                            <div style={{ width: 30 }}>
                                                <AudioIcon strokeColor="black"></AudioIcon>
                                            </div>
                                        </div>
                                    )}
                                </CtaLink>
                            </div>
                        )}
                        {attribution_name?.value && (
                            <div
                                className={styles.credentials}
                                data-kontent-element-codename="attribution_name"
                            >
                                {attribution_name?.value}
                            </div>
                        )}
                        {attribution_certification?.value && (
                            <div
                                className={styles.name}
                                data-kontent-element-codename="attribution_certification"
                            >
                                {attribution_certification?.value}
                            </div>
                        )}
                    </div>
                    {videoOrAudioFileUrl && (
                        <Modal
                            contentLabel="Media"
                            isOpen={modalIsOpen}
                            onRequestClose={() => {
                                setIsOpen(false);
                            }}
                            shouldCloseOnOverlayClick={true}
                        >
                            <ReactPlayer
                                className={styles.reactPlayer}
                                controls={true}
                                playing={true}
                                playIcon={
                                    <img
                                        src={ctaIcon?.url}
                                        alt="Play video"
                                        loading="lazy"
                                    />
                                }
                                width="100%"
                                height="100%"
                                previewTabIndex={1}
                                url={video_or_audio_file?.value[0]?.url}
                            />
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
};
export default PromotedContentStyleB;
function setImageAlignmentClass(imagePositionCase: itemsAlignmentType) {
    if (imagePositionCase == 'center_float') {
        return styles.centerFloatImage;
    }

    if (imagePositionCase == 'top_float') {
        return styles.topFloatImage;
    }

    if (imagePositionCase == 'bottom_float') {
        return styles.bottomFloatImage;
    }

    return {};
}

export const fragmentPromotedContentStyleB = graphql`
    fragment PromotedContentStyleB on kontent_item_component___promotional_style_b {
        elements {
            attribution_certification {
                value
            }
            attribution_name {
                value
            }
            content_panel__content_panel_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            content_panel__content_panel_font_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_type {
                value {
                    codename
                }
            }
            headline {
                value
            }
            icon_for_cta_button {
                value {
                    ... on kontent_item_media___icon {
                        id
                        elements {
                            icon_svg_file {
                                value {
                                    description
                                    width
                                    height
                                }
                            }
                            color {
                                value {
                                    codename
                                }
                            }
                        }
                    }
                }
            }
            paragraph {
                value
            }
            primary_image {
                ...kontentImage
            }
            primary_image_alignment {
                value {
                    codename
                }
            }
            video_or_audio_file {
                value {
                    url
                }
            }
            video_or_audio_file_link {
                value
            }
            video_or_audio_file_location {
                value {
                    codename
                }
            }
        }
    }
`;
